import { render, staticRenderFns } from "./ClientContact.vue?vue&type=template&id=6e531816"
import script from "./ClientContact.vue?vue&type=script&lang=js"
export * from "./ClientContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports